import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import moment from 'moment';

const contextPath = '/admin/asset'

export const useGetInspectInfo = (param) => {
    const sendParam = {
        sno: param && param.sno && param.sno > 0 ? param.sno : 0,
        isp_tp: param && param.isp_tp && param.isp_tp !== '' ? param.isp_tp : '',
        isp_kd: param && param.isp_kd && param.isp_kd !== '' ? param.isp_kd : '',
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('ASSET_INSPECT_INFO', () => getInspect(sendParam));
}

const getInspect = async (param) => {
    const retVal = await instance.get(contextPath+'/inspects', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetInspectSel = (param) => {
    const sendParam = {
        sno: param && param.sno && param.sno > 0 ? param.sno : 0,
        isp_tp: param && param.isp_tp && param.isp_tp !== '' ? param.isp_tp : '',
        isp_kd: param && param.isp_kd && param.isp_kd !== '' ? param.isp_kd : '',
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('ASSET_INSPECT_SEL', () => getInspectSel(sendParam));
}
const getInspectSel = async (param) => {
    const retVal = await instance.get(contextPath+'/inspects', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useSetInspect = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postInspect(sendParam);
                case 'PUT':
                    return putInspect(sendParam);
                case 'STATUS':
                    return modStatusInspect(sendParam);
                case 'DELETE':
                    return deleteInspect(sendParam);
                default :
                    return putInspect(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('ASSET_INSPECT_SEL', { refetchInactive: true })
            },
        }
    )
}

const postInspect = async (param) => {

    const sendParam = {
        isp_nm: param.isp_nm,
        isp_tp: param.isp_tp,
        isp_kd: param.isp_kd,
        reg_id: param.reg_id,
        sdate: moment(param.sdate).format('YYYYMMDD'),
        edate: moment(param.edate).format('YYYYMMDD'),
        isp_st: param.isp_st,
        contents: param.contents,
        descr: param.descr,
        is_use: 1,
    }

    const retVal = await instance.post(contextPath+'/inspects', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putInspect = async (param) => {

    const sendParam = {
        sno: param.sno,
        isp_nm: param.isp_nm,
        isp_tp: param.isp_tp,
        isp_kd: param.isp_kd,
        reg_id: param.reg_id,
        sdate: moment(param.sdate).format('YYYYMMDD'),
        edate: moment(param.edate).format('YYYYMMDD'),
        isp_st: param.isp_st,
        contents: param.contents,
        descr: param.descr,
        is_use: 1,
    }

    const retVal = await instance.put(contextPath+'/inspects', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const modStatusInspect = async (param) => {

    const sendParam = {
        sno: param.sno,
        isp_st: param.isp_st,
    }

    const retVal = await instance.put(contextPath+'/ispStatusMod', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const deleteInspect = async (param) => {

    const sendParam = {
        sno: param.sno,
    }

    const retVal = await instance.put(contextPath+'/delInspects', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetInspectHistSel = (param) => {

    const sendParam = {
        sno: param && param.sno && param.sno > 0 ? param.sno : 0,
        status: param && param.status && param.status !== '' ? param.status : '',
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }

    return useQuery('ASSET_INSPECT_HIST_SEL', () => getInspectHistSel(sendParam));
}
const getInspectHistSel = async (param) => {
    if(param.sno !== 0){
        const retVal = await instance.get(contextPath+'/inspectsHist', {params:param})
                                        .then((res)=>{
                                            return res.data[0];
                                        })
                                        // .catch((err)=>{
                                        //     return err;
                                        // })
        return retVal;
    }
}

export const useSetInspectHist = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postInspectHist(sendParam);
                case 'PUT':
                    return putInspectHist(sendParam);
                case 'DELETE':
                    return deleteInspectHist(sendParam);
                case 'POST_LIST':
                    return postInspectHistList(sendParam);
                default :
                    return putInspectHist(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('ASSET_INSPECT_HIST_SEL', { refetchInactive: true })
            },
        }
    )
}

const postInspectHist = async (param) => {

    const sendParam = {
        sno: param.sno,
        tid: param.tid,
        ret_st: param.ret_st,
        contents: param.contents,
        descr: param.descr
    }

    const retVal = await instance.post(contextPath+'/inspectsHist', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const postInspectHistList = async (param) => {

    const sendParam = param.list;
    const retVal = await instance.post(contextPath+'/inspectsHistList', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putInspectHist = async (param) => {

    const sendParam = {
        seq: param.seq,
        sno: param.sno,
        tid: param.tid,
        ret_st: param.ret_st,
        contents: param.contents,
        descr: param.descr
    }

    const retVal = await instance.put(contextPath+'/inspectsHist', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const deleteInspectHist = async (param) => {

    const sendParam = {
        seq: param.seq,
    }

    const retVal = await instance.put(contextPath+'/delInspectsHist', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetStaticInspect = (param) => {
    const sendParam = {
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        isp_tp: param && param.isp_tp && param.isp_tp !== '' ? param.isp_tp : '',
        isp_kd: param && param.isp_kd && param.isp_kd !== '' ? param.isp_kd : '',
    }
    return useQuery('ASSET_STATIC_INSPECT', () => getStaticInspect(sendParam));
}

const getStaticInspect = async (param) => {
    const retVal = await instance.get(contextPath+'/staticInspects', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}